<template>
<div >
</div>
</template>

<script>

    import { mapState, mapGetters } from 'vuex';
    export default {
        name: 'autologout',
        components: {
        },
        data () {
            return {
                events: ["click", "mousemove", "mousedown", "scroll", "keypress", "load"],
                warningOpened: false,
                warningTimer: null,
                logoutTimer: null,
            }
        },
        created: function () {

        },
        mounted: function (){
            this.events.forEach(event => {
                window.addEventListener(event, this.resetTimer);
            })
            this.setTimers();
        },
        beforeDestroy() {
            this.events.forEach(event => {
                window.removeEventListener(event, this.resetTimer);
            })
            this.clearTimers();

        },
        computed: {
            ...mapGetters(['storeId', 'storeSettings']),
            logoutTime() {
                let settings = this.storeSettings;
                let result = 15;
                if(settings != null && settings.autoLogoutTime != null){
                    result = settings.autoLogoutTime;
                }
                return result;
            }

        },
        watch: {
            storeSettings(newVal, oldVal){
                if(newVal != oldVal){
                    //console.log("Resetting logout timer from setting change")
                    this.resetTimer();
                }
            }
        },
        // methods that implement data logic.
        methods: {
            resetTimer() {
                this.clearTimers();
                this.setTimers();
            },
            clearTimers() {
                if(this.warningTimer != null){
                    clearTimeout(this.warningTimer);
                }
                if(this.logoutTimer != null){
                    clearTimeout(this.logoutTimer);
                }
            },
            setTimers() {
                let view = this;
                let time = this.logoutTime;
                if(time > 0){
                    time = Math.max(5, time);
                    //console.log("Setting Logout Time: "+time);
                    this.warningTimer = setTimeout(view.OpenWarningPopup, time*60*1000)
                    this.logoutTimer = setTimeout(view.logout, time*60*1000 + 30*1000)
                }

            },
            logout: function () {
                localStorage.removeItem('md_token');
                localStorage.removeItem('selected_store');
                localStorage.removeItem('selected_company');

                let sub = this.getSubDomain();
                if(sub ==="staging") {
                    window.location = "https://account.meindienstplan.at/#/logout?redirect=stagingmdpl";
                } else if(sub === "development") {
                    window.location = "https://account.meindienstplan.at/#/logout?redirect=devmdpl";
                } else if(sub.startsWith("localhost")) {
                    window.location = "https://account.meindienstplan.at/#/logout?redirect=localmdpl";
                } else {
                    window.location = "https://account.meindienstplan.at/#/logout?redirect=mdpl";
                }

            },
            getSubDomain: function(){
                let full = window.location.host
                //window.location.host is subdomain.domain.com
                let parts = full.split('.')
                return parts[0]
            },
            OpenWarningPopup(){
                let view = this;
                if(!this.warningOpened){
                    view.warningOpened = true;
                    view.$helpers.OpenPopup({
                        type: 'datafill',
                        componentState: {
                            entries: [],
                            description: this.$t('global.ui.logoutWarning', [view.logoutTime]),
                            positiveButtonLabel: this.$t('global.ui.cancelLogout'),
                            selectCallback: function (data) {
                                view.warningOpened = false;
                            },

                        },
                        header: this.$t('global.ui.inactivity'),
                        expanded: true,
                        toggleCallback: (dropdowncontainer) => {
                            view.warningOpened = false;
                        },
                        width: "700px",
                        centered: true
                    });
                }

            }

        },

    }
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>

</style>
